import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { EmptyState } from "@/admin/ui";
import { toast } from "sonner";
import { PageHeader } from "@/user/workspace/wsui";
import { ws, fmtBytes, fmtDate, downloadAttachment } from "@/user/workspace/ws.api";

function extIcon(name) {
    const ext = (name || "").split(".").pop().toLowerCase();
    if (["png", "jpg", "jpeg", "gif", "webp"].includes(ext)) return "image";
    if (["xls", "xlsx", "csv"].includes(ext)) return "sheet";
    if (["pdf"].includes(ext)) return "pdf";
    return "doc";
}

export default function Documents() {
    const { user } = useOutletContext();
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { ws.listDocuments().then(setDocs).finally(() => setLoading(false)); }, []);

    async function download(d) {
        try { const full = await ws.getAttachment(d.id); downloadAttachment(full); }
        catch { toast.error("Download failed"); }
    }

    return (
        <div data-testid="page-documents">
            <PageHeader
                eyebrow={user.name?.split(" ")[0] || "You"}
                title="Documents"
                subtitle="Every file you've uploaded across your submissions, in one place."
            />
            {loading ? (
                <div className="text-neutral-500 py-16 text-center">Loading…</div>
            ) : docs.length === 0 ? (
                <EmptyState title="No documents yet" hint="Attach files when submitting an update and they'll appear here." />
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="doc-grid">
                    {docs.map((d) => (
                        <div key={d.id} data-testid={`doc-${d.id}`} className="glass rounded-2xl p-5 flex flex-col hover:-translate-y-0.5 transition-all duration-300">
                            <div className="flex items-center gap-3">
                                <span className="h-10 w-10 rounded-xl bg-violet-50 text-violet-600 inline-flex items-center justify-center text-[10px] font-semibold uppercase">
                                    {extIcon(d.filename) === "image" ? "IMG" : extIcon(d.filename) === "sheet" ? "XLS" : extIcon(d.filename) === "pdf" ? "PDF" : "DOC"}
                                </span>
                                <div className="min-w-0">
                                    <div className="text-[13.5px] font-medium text-black truncate">{d.filename}</div>
                                    <div className="text-[11px] text-neutral-400">{fmtBytes(d.size)} · {fmtDate(d.uploaded_at)}</div>
                                </div>
                            </div>
                            <button onClick={() => download(d)} data-testid={`doc-download-${d.id}`} className="mt-4 self-start text-violet-600 hover:text-violet-700 text-[12px] font-medium">Download →</button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
